import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export default function CalendarDebugger() {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const addLog = (message, type = 'info') => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev, { message, type, timestamp }]);
    console.log(`[${timestamp}] ${message}`);
  };

  const clearLogs = () => {
    setLogs([]);
  };

  const testEnvironmentVariables = () => {
    addLog('Testing environment variables...');
    
    const clientId = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    
    addLog(`Google Client ID: ${clientId ? '✓ Configured' : '✗ Missing'}`, clientId ? 'success' : 'error');
    addLog(`Supabase URL: ${supabaseUrl ? '✓ Configured' : '✗ Missing'}`, supabaseUrl ? 'success' : 'error');
    addLog(`Supabase Key: ${supabaseKey ? '✓ Configured' : '✗ Missing'}`, supabaseKey ? 'success' : 'error');
  };

  const runAllTests = async () => {
    clearLogs();
    addLog('Running basic calendar integration tests...', 'info');
    
    testEnvironmentVariables();
    
    addLog('Basic tests completed! Check browser console for detailed logs.', 'success');
  };

  return (
    <Card className="w-full max-w-4xl mx-auto">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Calendar Integration Debugger
          <Badge variant="outline">Debug</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-2">
          <Button onClick={runAllTests} disabled={isLoading} variant="default">
            {isLoading ? 'Running...' : 'Run Basic Tests'}
          </Button>
          <Button onClick={testEnvironmentVariables} disabled={isLoading} variant="outline">
            Test Environment
          </Button>
          <Button onClick={clearLogs} variant="outline">
            Clear Logs
          </Button>
        </div>
        
        <div className="bg-slate-50 rounded-lg p-4 max-h-96 overflow-y-auto">
          <h4 className="font-medium mb-2">Debug Logs:</h4>
          {logs.length === 0 ? (
            <p className="text-slate-500 text-sm">No logs yet. Run a test to see results.</p>
          ) : (
            <div className="space-y-1">
              {logs.map((log, index) => (
                <div key={index} className={`text-sm font-mono ${
                  log.type === 'error' ? 'text-red-600' :
                  log.type === 'success' ? 'text-green-600' :
                  'text-slate-700'
                }`}>
                  <span className="text-slate-400">[{log.timestamp}]</span> {log.message}
                </div>
              ))}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
